import { render, staticRenderFns } from "./InputParamerter.vue?vue&type=template&id=b910912c"
import script from "./InputParamerter.vue?vue&type=script&lang=js"
export * from "./InputParamerter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports